var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMarketplace = function SvgMarketplace(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(6 7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#579FD7",
    d: "M8.276 14.828L11.724 14.828 11.724 18.621 8.276 18.621z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDD1F2",
    d: "M10 16.897c-.19 0-.345-.155-.345-.345v-1.724c0-.19.155-.345.345-.345.19 0 .345.154.345.345v1.724c0 .19-.155.345-.345.345z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 12.069,
    y: 2.759,
    fill: "#D3ECFF",
    rx: 0.889
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7D9FF",
    d: "M7.241 18.621L12.759 18.621 12.759 20 7.241 20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#579FD7",
    d: "M3.793 2.759L16.207 2.759 16.207 11.034 3.793 11.034z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC431",
    d: "M3.793 2.759h2.07v1.034c0 .571-.464 1.035-1.035 1.035-.572 0-1.035-.464-1.035-1.035V2.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB401",
    d: "M5.862 2.759h2.069v1.034c0 .571-.463 1.035-1.034 1.035-.572 0-1.035-.464-1.035-1.035V2.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC431",
    d: "M7.931 2.759H10v1.034c0 .571-.463 1.035-1.034 1.035-.572 0-1.035-.464-1.035-1.035V2.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB401",
    d: "M10 2.759h2.069v1.034c0 .571-.463 1.035-1.035 1.035-.57 0-1.034-.464-1.034-1.035V2.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC431",
    d: "M12.069 2.759h2.069v1.034c0 .571-.463 1.035-1.035 1.035-.57 0-1.034-.464-1.034-1.035V2.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB401",
    d: "M14.138 2.759h2.069v1.034c0 .571-.463 1.035-1.035 1.035-.57 0-1.034-.464-1.034-1.035V2.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7D9FF",
    d: "M11.724 6.207L14.483 6.207 14.483 11.034 11.724 11.034zM5.517 6.207L10 6.207 10 9.31 5.517 9.31z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.759,
    cy: 8.621,
    r: 1,
    fill: "#B2C6EB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB401",
    d: "M5.862 2.759L7.241 0 5.172 0 3.793 2.759z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA100",
    d: "M7.931 2.759L9.31 0 7.241 0 5.862 2.759z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB401",
    d: "M10 2.759L11.379 0 9.31 0 7.931 2.759z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA100",
    d: "M12.069 2.759L13.448 0 11.379 0 10 2.759z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB401",
    d: "M15.172 0.69L14.138 2.759 12.069 2.759 13.448 0 14.828 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA100",
    d: "M16.207 2.759L14.138 2.759 15.172 0.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDD1F2",
    d: "M1.724 10.69L18.276 10.69 18.276 11.379 1.724 11.379z"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarketplace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/marketplace.3ce61857.svg";
export { ForwardRef as ReactComponent };